import $ from '@modules/jquery-import';

/**
 * sortElements - Sort a jquery nodeList
 * @param {Function} - comparator function to define sort criteria
 * @param {Function} - getSortable function that returns node to be sorted in DOM, defaults to this
 */
$.fn.sortElements = (function () {
    // borrow native sort
    var sort = [].sort;

    return function ( comparator, getSortable ) {

        if ( !this[0] ) {
            // no elements to sort
            return;
        }

        // sort by nodeValue (text) by default
        comparator = comparator || function ( a, b ) {
            return $( a ).text() > $( b ).text()
                ? 1
                : -1;
        };
        getSortable = getSortable || function () {
            return this;
        };

        // get parentNode of the sortable nodes
        var parentNode = getSortable.call( this[0] ).parent();

        // map a callback for each element in the nodeList to place itself within parent
        // this allows to sort nodeList first then insert back into DOM
        var placeElement = this.map( function () {
            return function () {
                if ( parentNode[0] === this ) {
                    throw new Error( 'You cannot sort elements if any are decendants of another' );
                }

                // insert sorted node
                parentNode.append( this );
            };
        } );

        // clear parent
        parentNode.empty();
        return sort.call( this, comparator ).each( function ( i ) {
            placeElement[i].call( getSortable.call( this ) );
        } );
    };

}());
